import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json; charset=utf-8',    
    })    
};

@Injectable()
export class DashboardService {

    constructor(private http: HttpClient) { }

    getBatch(rootUrl:string, usercode: string, subuser_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/batch', {usercode: usercode, subuser_id:subuser_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }
}